import Model from './Model'
import Template from './Template'

export default class SubCategory extends Model {
  id: number
  title: string
  imageId: number
  templates: []

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.title = this.translateField(json._title, locale)
    this.imageId = json.cached_id

    this.templates = json.template_ids.map((template) => new Template(template, locale))
  }
}
